"use client";

import dynamic from "next/dynamic";
import { MathJaxContext } from "better-react-mathjax";

const MathJax = dynamic(
  () => import("better-react-mathjax").then((mod) => mod.MathJax),
  {
    ssr: false,
  },
);

export default function MathWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const mathJaxConfig = {
    loader: { load: ["[tex]/ams"] },
    chtml: {
      scale: 0.8,
      minScale: 0.5,
      displayOverflow: "linebreak",
      displayAlign: "left",
      displayIndent: "0",
      linebreaks: { inline: true, width: "100%" },
    },
    tex: {
      inlineMath: [
        ["$", "$"],
        ["\\(", "\\)"],
      ],
      displayMath: [
        ["$$", "$$"],
        ["\\[", "\\]"],
      ],
      processEscapes: true,
      autoload: {
        color: [],
        colorv2: ["color"],
      },
      packages: { "[+]": ["noerrors"] },
    },
    options: {
      enableMenu: false,
      ignoreHtmlClass: "tex2jax_ignore",
      processHtmlClass: "tex2jax_process",
    },
  };
  return (
    <MathJaxContext config={mathJaxConfig}>
      <MathJax>{children}</MathJax>
    </MathJaxContext>
  );
}
